import type { AppLocale } from "./index"
import { EXTENDED_GARAGE_UI } from "./extendedLocaleUi"
import { isExtendedLocale } from "./isExtendedLocale"
import { garageUi as legacyGarageUi, type GarageUiKey } from "./legacy/garageUi"
import type { AppLocale as LegacyAppLocale } from "./legacy/index"
import { PUBLIC_EXTRA_GARAGE_UI } from "./publicExtraBasicUi"
import { isPublicExtraLocale } from "./publicExtraSignals"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { isExpansionLocale } from "./publicExpansionSignals"
import { EXPANSION_GARAGE_UI } from "./publicExpansionBasicUi"

export type { GarageUiKey } from "./legacy/garageUi"

export function garageUi(locale: AppLocale, key: GarageUiKey): string {
  if (isExpansionLocale(locale)) return EXPANSION_GARAGE_UI[locale][key]
  if (isPublicExtraLocale(locale)) {
    return PUBLIC_EXTRA_GARAGE_UI[locale][key]
  }
  if (isExtendedLocale(locale)) {
    return (EXTENDED_GARAGE_UI[locale] as Record<GarageUiKey, string>)[key]
  }
  const value = legacyGarageUi(locale as LegacyAppLocale, key)
  return locale === "uz" ? uzbekLatinToCyrillic(value) : value
}
